import { RefreshCw } from "lucide-react";

export function VersionBanner({ visible, onReload }) {
  if (!visible) return null;
  return (
    <div
      data-testid="version-banner"
      className="bg-amber-500 text-amber-950 text-sm px-4 py-2 flex items-center justify-center gap-3 shrink-0"
    >
      <span>Hay una nueva versión disponible.</span>
      <button
        data-testid="version-banner-reload-button"
        onClick={onReload}
        className="flex items-center gap-1 font-semibold underline"
      >
        <RefreshCw className="h-3.5 w-3.5" /> Recargar
      </button>
    </div>
  );
}
